export default __webpack_public_path__ + "static/media/DownArrow.b4e2ab0f.svg";